
import {Component, Prop, Vue} from "vue-property-decorator";

    @Component
    export default class YesNoDialog extends Vue {
      @Prop({required: true}) headline: string;
      @Prop() text: string;
    }
